export const Section = ({ title, children }) => (
  <section className="space-y-6 mb-10">
    <h3 className="text-2xl font-bold text-gray-900">{title}</h3>
    <div className="text-gray-700 leading-relaxed space-y-4">{children}</div>
  </section>
);
